import React from 'react'
import { Link } from 'gatsby'
import { css } from 'emotion'
import { Links } from './Links'
import Img from 'gatsby-image'

export const HEADER_HEIGHT = '256px'

export const styles = {}
styles.wrapper = css`
  background: black;
  /* margin-bottom: 1.45rem; */
  min-height: ${HEADER_HEIGHT};
  max-height: ${HEADER_HEIGHT};
  display: flex;
  justify-content: flex-end;
  flex-direction: column;
  position: relative;
  .container {
    width: 100%;
    margin: 0 auto;
    max-width: 960px;
    padding: 1.45rem 1.0875rem;
    padding-bottom: 0;
    z-index: 10;
  }
  a {
    color: white;
    text-decoration: none;
  }
  .shade {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-shadow: 0px -250px 100px -100px black inset;
    content: '';
  }
`
styles.headerImageStyle = {
  position: 'absolute',
  width: '100%',
  height: '100%',
}

/**
 * Loads a fluid image from data.
 * @param {*} image The raw image data from query.
 */
function loadImage(image) {
  if (image) {
    if (typeof image === 'string' || image.src) {
      return <Img fluid={image} style={styles.headerImageStyle} />;
    } else {
      return image;
    }
  } else {
    return null;
  }
}

export const Header = ({ title, active, image }) => (
  <div className={styles.wrapper}>
    {loadImage(image)}
    <div className="shade" />
    <div className="container">
      <h1 style={{ margin: 0 }}>
        <Link to="/">{title}</Link>
      </h1>
      <Links active={active} />
    </div>
  </div>
)
